﻿import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Tag, Intent } from "@blueprintjs/core";
import './Status.css';
import './EmployeeCircleStatus.css';
import './StatusPanel.css';

export function ActiveStatus(
    {
        isActive = true,
        loading = false,
        activeText = 'Active',
        inactiveText = 'Inactive'
    }
) {
            
    return (
        <Tag
            className={classNames('active-status', { "bp6-skeleton": loading })}
            intent={isActive ? Intent.SUCCESS : Intent.DANGER}
        >
            {isActive ? activeText : inactiveText}
        </Tag>
    );    
}

ActiveStatus.propTypes = {
    isActive: PropTypes.bool,    
    loading: PropTypes.bool,
    activeText: PropTypes.string,
    inactiveText: PropTypes.string
};